import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./not-found.css";

export default function NotFoundPage() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isEn = (i18n.language || "").toLowerCase().startsWith("en");
  const adminish = location.pathname.startsWith("/admin");

  useEffect(() => {
    const prev = document.title;
    document.title = `${t("notFound.browserTitle")} · VizHacks`;
    return () => {
      document.title = prev;
    };
  }, [t]);

  return (
    <section
      className={`vh-not-found${isEn ? " vh-not-found--en" : ""}`}
      aria-labelledby="not-found-title"
    >
      <div className="vh-not-found__inner container-n">
        <p className="vh-not-found__code" aria-hidden="true">
          {t("notFound.code")}
        </p>
        <h1 id="not-found-title" className="vh-not-found__title">
          {adminish ? t("notFound.titleAdmin") : t("notFound.title")}
        </h1>
        <p className="vh-not-found__desc">
          {adminish ? t("notFound.descAdmin") : t("notFound.desc")}
        </p>
        <div className="vh-not-found__actions">
          {adminish ? (
            <Link className="vh-not-found__btn vh-not-found__btn--primary" to="/admin">
              {t("notFound.adminLogin")}
            </Link>
          ) : (
            <>
              <Link className="vh-not-found__btn vh-not-found__btn--primary" to="/">
                {t("notFound.home")}
              </Link>
              <Link className="vh-not-found__btn vh-not-found__btn--secondary" to="/#contact-us">
                {t("notFound.contact")}
              </Link>
            </>
          )}
        </div>
        <p className="vh-not-found__path">
          <span className="vh-not-found__path-k">{t("notFound.pathLabel")}</span>
          {location.pathname || "/"}
        </p>
      </div>
    </section>
  );
}
